import { API_ENDPOINT } from '../../config'
import customFetch from '../../utils/customFetch'
import { normalizeAiExtractionResponse } from './aiDataExtractionNormalize'
import { AiExtractionRequest, AiExtractionResponse } from './types'

const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/ai/extract`

export const extractAiData = async (payload: AiExtractionRequest): Promise<AiExtractionResponse> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include' as const,
    body: JSON.stringify(payload),
  }

  const response = await customFetch(url, options)
  if (response.status !== 200) {
    throw new Error(`Cannot extract ai data, failed with ${response.status} and message ${await response.text()}`)
  }

  return normalizeAiExtractionResponse(await response.json())
}
